import { action, observable, computed, toJS } from "mobx";
import PagerStore from "./utility/PagerStore";
import { SORT_ITEM } from "../Containers/TableSum/TableSum";
import { formatDate } from "utility.js";
import {
  SORT_TYPE,
  SORT_DEVICE,
  SORT_USER,
  SORT_DURATION,
  SORT_FROM,
  SORT_TO,
} from "../Containers/StatActivity/StatActivity";

const STORE_STAT_ACTIVITY = "statactivity";

const SORT_ASC = "asc";
const SORT_DESC = "desc";

class StatActivityStore {
  pager;
  configStore;
  authStore;

  constructor(rawState = {}, configStore, authStore) {
    this.configStore = configStore;
    this.authStore = authStore;
    this.pager = new PagerStore(rawState.pager);

    if (rawState.items) {
      this.setItems(rawState.items);
    }
    if (rawState.search) {
      this.setSearch(rawState.search);
    }
    if (rawState.sortField) {
      this.setSortField(rawState.sortField);
    }
    if (rawState.sortDirection) {
      this.setSortDirection(rawState.sortDirection);
    }
    if (rawState.sealnums) {
      this.setSealnums(rawState.sealnums);
    }
  }
  toJS() {
    return {
      items: toJS(this.items),
      search: toJS(this.search),
      pager: toJS(this.pager),
      sortField: toJS(this.sortField),
      sortDirection: toJS(this.sortDirection),
      sealnums: toJS(this.sealnums),
    };
  }

  @observable items = [];
  @action setItems(value) {
    this.items = value.map((item) => {
      if (item.To) {
        let duration = parseInt(
          (new Date(item.To).getTime() - new Date(item.From).getTime()) /
            1000 /
            60
        );
        const hours = Math.floor(duration / 60);
        const minutes = duration - hours * 60;
        item.Duration =
          String(hours).padStart(2, 0) + ":" + String(minutes).padStart(2, 0);
      }

      item.FilterField = (
        item.Type +
        " " +
        item.From +
        " " +
        item.To +
        " " +
        item.Device +
        " " +
        item.User +
        " " +
        item.Distance
      ).toLowerCase();
      return item;
    });
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable from;
  @action setFrom(value) {
    this.from = value;
  }
  @computed get fromFormatted() {
    return formatDate(this.from);
  }

  @observable to;
  @action setTo(value) {
    this.to = value;
  }
  @computed get toFormatted() {
    return formatDate(this.to);
  }

  @observable search = "";
  @action setSearch(value) {
    this.search = value;
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable device = null;
  @action setDevice(value) {
    this.device = value;
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable user = null;
  @action setUser(value) {
    this.user = value;
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable sortField;
  @action setSortField(value) {
    this.sortField = value;
  }

  @observable sortDirection;
  @action setSortDirection(value) {
    this.sortDirection = value;
  }
  @action flipSortDirection() {
    this.sortDirection = this.sortDirection === SORT_ASC ? SORT_DESC : SORT_ASC;
  }

  @computed get filteredItems() {
    if (!this.search && !this.device && !this.user) {
      return this.items;
    }
    const collator = new Intl.Collator();

    return observable(
      this.items
        .filter((item) => {
          if (
            !this.device ||
            collator.compare(
              item.Device.normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase(),
              this.device.value
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
            ) === 0
          )
            return true;
          return false;
        })
        .filter((item) => {
          console.log(item, this.user);
          if (!this.user || item.User === this.user.label) return true;
          return false;
        })
        .filter((item) => {
          const searches = this.search.split(" ");
          for (let i = 0; i < searches.length; i++) {
            const s = searches[i].toLowerCase();
            //console.log(s, item.FilterField)
            if (item.FilterField.indexOf(s) === -1) {
              return false;
            }
          }
          return true;

          for (let fieldValue of Object.values(item)) {
            if (("" + fieldValue).indexOf(this.search) > -1) {
              return true;
            }
          }
          return false;
        })
    );
  }

  @computed get sortedItems() {
    if (!this.sortDirection || !this.sortField) {
      return this.filteredItems;
    }
    const sortedItems =
      [
        SORT_TYPE,
        SORT_DURATION,
        SORT_USER,
        SORT_DEVICE,
        SORT_FROM,
        SORT_TO,
      ].indexOf(this.sortField) > -1
        ? this.filteredItems.slice().sort((a, b) => {
            if (!a[this.sortField]) return -1;
            if (!b[this.sortField]) return 1;
            return a[this.sortField]
              ? a[this.sortField].localeCompare(b[this.sortField])
              : -1;
          })
        : this.filteredItems.slice().sort((a, b) => {
            const v1 = a == null ? 0 : parseInt(a[this.sortField]);
            const v2 = b == null ? 0 : b[this.sortField];
            if (v1 === v2) return 0;
            return v1 > v2 ? 1 : -1;
          });

    return observable(
      this.sortDirection === SORT_ASC ? sortedItems : sortedItems.reverse()
    );
  }

  @computed get shownItems() {
    return this.sortedItems.slice(
      this.pager.firstShownItem - 1,
      this.pager.lastShownItem
    );
  }

  @observable details;
  @action setDetails(value) {
    this.details = value;
  }
}

export { StatActivityStore, STORE_STAT_ACTIVITY, SORT_ASC, SORT_DESC };
